import { List, Spin } from "antd";
import { usePostBaobPcComplaintRecordList } from "@/openapi/baob/pc.complaint/api.client.hooks";
import FeedbackItem from "@/components/HeaderFeedback/FeedbackItem";
import { FeedbackItemType } from "@/components/HeaderFeedback/types";
import { useEffect, useRef } from "react";
import { useInViewport } from "ahooks";
import { getCurrentUser, getCurrentShopData } from "@/utils/storage";

interface FeedbackListProps {
  onClickItem: (feedbackData: FeedbackItemType) => void;
}
const FeedbackList = ({ onClickItem }: FeedbackListProps) => {
  const divRef = useRef<HTMLDivElement>(null);
  const [inViewport] = useInViewport(divRef);
  const currentUser = getCurrentUser();
  const currentShop = getCurrentShopData();
  const {
    isLoading: loading,
    isFetchingNextPage,
    hasNextPage,
    fetchNextPage,
    data,
  } = usePostBaobPcComplaintRecordList({
    params: {
      pageNumber: 1,
      pageSize: 20,
      supply_id: currentShop?.supplierId,
      shopId: currentShop?.shopId,
      roleId: currentUser?.roleId,
    },
  });

  useEffect(() => {
    if (inViewport && !isFetchingNextPage) {
      fetchNextPage();
    }
  }, [fetchNextPage, inViewport, isFetchingNextPage]);

  return (
    <Spin spinning={loading}>
      <List
        dataSource={data?.pages[0].data.dataList}
        renderItem={(item) => (
          <List.Item
            key={item.complaintId}
            className="bg-white rounded mb-2 hover:shadow-md"
            onClick={() => onClickItem(item)}
          >
            <FeedbackItem data={item} />
          </List.Item>
        )}
        className="h-full overflow-y-auto"
      />
      <div
        ref={divRef}
        className="text-[#999999] w-full py-2 flex items-center justify-center"
      >
        {hasNextPage ? "正在加载..." : "没有更多数据了"}
      </div>
    </Spin>
  );
};

export default FeedbackList;
